import { axiosInstance, parseResult } from "./CommonApi";

//RTU 수신 로그 리스트 조회
export const getRtuReceiveLogs = async (rtuImei, page, pageSize) => {
  const params = {
    rtu_imei: rtuImei,
    page: page,
    page_size: pageSize,
  };
  const response = await axiosInstance.get(`/rtu/receive-log/`, {
    params,
  });
  return parseResult(response);
};

export const getRtuReceiveLogsByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//RTU 수신 로그 리스트 엑셀 저장
export const exportExcelRtuReceiveLogs = async (rtuImei) => {
  const params = { rtu_imei: rtuImei };
  const response = await axiosInstance.post(
    `/rtu/receive-log/export/`,
    {},
    { params, responseType: "blob" }
  );

  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};
